import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFileUpload } from "../types/File/FileUpload";


const FileSlice = createSlice({
    name: "fileDetails",
    initialState: {
        files: [] as IFileUpload[],
    },
    reducers: {
        ResetFiles: (state, action) => {
            state.files = [];
        },
        SetFiles: (state, action: PayloadAction<IFileUpload[]>) => {
            state.files = action.payload;
        }
    }
})

export const { ResetFiles, SetFiles } = FileSlice.actions
export default FileSlice.reducer
